'use server';
import { actionErrorMessage } from '@/shared/infrastructure/logging/actionError';

import type { ActionResult } from '@/shared/types/actions';
import { SessionService } from '@/contexts/authentication';
import { StoryService } from '@/contexts/stories/services/StoryService';

export async function deleteStory(storyId: string): Promise<ActionResult<void>> {
  try {
    const familyId = await SessionService.getFamilyId();
    const userId = await SessionService.getUserId();
    if (!familyId || !userId) return { success: false, error: 'Not authenticated' };

    await StoryService.deleteStory({ storyId, familyId });

    return { success: true, data: undefined };
  } catch (e: unknown) {
    return { success: false, error: actionErrorMessage('deleteStory', e) };
  }
}
